import { render, staticRenderFns } from "./ClubsAddress.vue?vue&type=template&id=612ad4bc&scoped=true"
import script from "./ClubsAddress.vue?vue&type=script&lang=js"
export * from "./ClubsAddress.vue?vue&type=script&lang=js"
import style0 from "./ClubsAddress.vue?vue&type=style&index=0&id=612ad4bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612ad4bc",
  null
  
)

export default component.exports